var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper profile-wrap"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _vm._m(0), _c('div', {
    staticClass: "row profileInfo-card"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "ds-accInfo-card"
  }, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "My Profile",
      "active": _vm.activeBusinessTab
    }
  }, [_c('b-card-text', [_c('business-setting', {
    attrs: {
      "businessSettings": _vm.businessSettings
    }
  })], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Display Settings",
      "active": _vm.activeDisplayTab
    }
  }, [_c('b-card-text', [_c('display-setting', {
    attrs: {
      "displaySettings": _vm.displaySettings
    }
  })], 1)], 1)], 1)], 1)], 1)])])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My Profile")])]);
}]

export { render, staticRenderFns }